import { EligibilityPickerField } from './EligibilityPickerField'

import {
  type FormFieldDescriptor,
  type NarrowFieldsByValueType,
  type TidalFormBridgeOptions,
  type TidalFormState,
  useTidalFormBridge,
} from '@workwave-tidal/core/form'

export type EligibilityPickerFieldProps = {
  testId?: string
  label: string
}

export type InputValue = uui.domain.client.rm.Eligibility

export type InputProps<
  TargetField extends NarrowFieldsByValueType<AcceptedFormValue, State, FormFieldDescriptor<State>>,
  State extends TidalFormState,
  AcceptedFormValue = InputValue,
> = {
  eligibilityPickerFieldProps: EligibilityPickerFieldProps
} & TidalFormBridgeOptions<InputValue, TargetField, State, AcceptedFormValue>

export function EligibilityPickerFieldWrapper<
  TargetField extends NarrowFieldsByValueType<AcceptedFormValue, State, FormFieldDescriptor<State>>,
  State extends TidalFormState,
  AcceptedFormValue = InputValue,
>(props: InputProps<TargetField, State, AcceptedFormValue>) {
  const {
    eligibilityPickerFieldProps: { testId, label },
    initialValue,
    validateOn = 'change',
    ...bridgeOptions
  } = props

  const {
    fieldInfo: { value, onChange, fieldHasError },
  } = useTidalFormBridge<InputValue, TargetField, State, AcceptedFormValue>({
    ...bridgeOptions,
    validateOn,
    initialValue,
  })

  return (
    <EligibilityPickerField
      label={label}
      testid={testId}
      onChange={onChange}
      value={value}
      error={fieldHasError}
    />
  )
}
